import { getMaterialHijoEnDescarga, getMaterialPadreEnDescarga } from "../common";
import { DESCARGO_POR_LISTA_MATERIALES, DESCARGO_UNO_A_UNO, DescargaCommonGlobal } from "../descarga.global";
import { obtenerContenedoresImportacionValidos } from "../descarga.validacion";
import { ALERT_ESTE_MATERIAL_NO_TIENE_LISTA, setLabelMaterialEnDescarga } from "../view/dataTableDetallePedimento";
import { dataTableDescarga } from "./DataTableDescarga";
import { dataTableDetalle } from "./DataTableDetallePedimento";
import { dataTablePedimentos } from "./DataTablePedimentos";
import { clearItemSelected } from "./utils";

const buildDataToDataTableDetalle = (materialPadreData, materialHijo, cantidadNecesaria) => [
    {
        ...materialPadreData,
        material: materialHijo,
        cantidad: cantidadNecesaria,
    },
];

/**
 * Recupera los datos del material para mostrar en pantalla
 * @param {number} pedimentoId
 * @returns
 */
export function getDataHijoEnDescarga() {
    const materialPadre = getMaterialPadreEnDescarga();

    setLabelMaterialEnDescarga(materialPadre.material);

    const { listaMateriales } = materialPadre;
    if (!listaMateriales) return [];

    const materialHijo = getMaterialHijoEnDescarga(materialPadre);

    const cantidadNecesaria = materialHijo.cantidadPorDescargar;

    return buildDataToDataTableDetalle(materialPadre, materialHijo.material_hijo, cantidadNecesaria);
}

const muestraContenedoresImportacionParaDescargar = () => {
    if (DescargaCommonGlobal.contenedoresImportacionParaDescargar.length === 0) {
        return;
    }

    const materialPadreEnDescarga = getMaterialPadreEnDescarga();
    const { material, fecha: fechaPago, clave_documento } = materialPadreEnDescarga;

    let materialEnDescarga = material;
    if (DescargaCommonGlobal.enDescarga.tipo === DESCARGO_POR_LISTA_MATERIALES) {
        const { material_hijo } = getMaterialHijoEnDescarga(materialPadreEnDescarga);
        materialEnDescarga = material_hijo;
    }

    DescargaCommonGlobal.contenedoresImportacionValidadosParaDescarga = obtenerContenedoresImportacionValidos(
        materialEnDescarga,
        fechaPago,
        clave_documento,
    );
    dataTableDescarga.options.data = DescargaCommonGlobal.contenedoresImportacionValidadosParaDescarga;
    dataTableDescarga.rowmanager.checkAll(false);
    dataTableDescarga.refresh();
};

export function mostrarDetallePedimentoSeleccionado(pedimentoId) {
    const isDataTableDescargaData = dataTableDescarga.options.data.length > 0;
    if (isDataTableDescargaData) {
        dataTableDescarga.options.data = [];
        dataTableDescarga.refresh();
    }

    dataTableDetalle.options.data = [];
    dataTableDetalle.options.noDataMessage = "Sin mercancías disponibles";
    dataTableDetalle.refresh();

    let data = [];
    if (!DescargaCommonGlobal.enProceso) {
        data = DescargaCommonGlobal.pedimentosExportacionValidos[pedimentoId].detalle;
    } else if (DescargaCommonGlobal.enDescarga.tipo === DESCARGO_UNO_A_UNO) {
        const material = getMaterialPadreEnDescarga();
        data = [material];
    } else {
        data = getDataHijoEnDescarga();
        if (data.length === 0) {
            dataTableDetalle.options.noDataMessage = ALERT_ESTE_MATERIAL_NO_TIENE_LISTA;
        }
    }

    dataTableDetalle.options.data = data;
    dataTableDetalle.refresh();

    if (DescargaCommonGlobal.contenedoresImportacionParaDescargar.length === 0) {
        return;
    }

    muestraContenedoresImportacionParaDescargar();
}

export const onClickRowDataTablePedimento = (event) => {
    if (DescargaCommonGlobal.enProceso) {
        return;
    }

    const { currentTarget } = event;
    const clickedElement = currentTarget.parentElement;
    const { rowIndex } = clickedElement.dataset;

    clearItemSelected();

    const pedimentoSeleccionado = dataTablePedimentos.options.data[rowIndex];
    dataTablePedimentos.options.data[rowIndex]["item-selected"] = pedimentoSeleccionado.pedimento_id;
    dataTablePedimentos.refresh();

    mostrarDetallePedimentoSeleccionado(pedimentoSeleccionado.pedimento_id);
};
